goog.provide('el8.service.urls');

el8.service.urls = (function() {

    var urlMap = {};

    return {
        init: function(spec) {
            for (var key in spec) {
                if (spec.hasOwnProperty(key) && spec[key]) {
                    this.add(key, spec[key]);
                }
            }
        },
        add: function(name, url) {
            urlMap[name] = url;
        },
        get: function(name, args) { // args is an array
            var url = urlMap[name] || null;
            if (url instanceof Function) {
                if (args === undefined) {
                    url = url.apply(this); // IE8 freaks out otherwise
                } else {
                    url = url.apply(this, args);
                }
            }
            if (!url) { UIM && UIM.logError('URL does not exist: ' + name); }
            return url;
        },
        post: function(name, args) { // args is an array
            var url = urlMap[name] || null;
            if (url instanceof Function) {
                if (args === undefined) {
                    url = url.apply(this);  // IE8 freaks out otherwise
                } else {
                    url = url.apply(this, args);
                }
            }
            if (!url) { UIM && UIM.logError('URL does not exist: ' + name)}
            return url;
        },
        hasUrl: function(name) {
            return Boolean(urlMap[name] || null);
        }
    };

})();
